<!-- starts:Hero section -->
<div class="container">
    <section class="hero-section">
        <!-- Overlay -->
        <div class="hero-overlay"></div>
        <!-- Background Image -->
        <img src="media/images/quran.jpg" alt="المكتبات الوقفية" class="hero-bg">
        <div class="container position-relative z-1 h-100">
            <div class="container row h-100 align-items-center">
                <div class="col-md-7 custom-offset">
                    <div class="hero-content text-white">
                        <h1 class="hero-title" translate="hero.title"></h1>
                        <span class="hero-subtitle" translate="hero.desc"></span>
                        <!-- Search -->
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="input-box input-content">
                                <img loading="lazy" src="media/icons/search.svg" alt="المستودع الرقمي" />
                                <input (keyup.enter)="onSearchClick(searchInputValue)" [(ngModel)]="searchInputValue"
                                    type="text" [placeholder]="'hero.searchtext' | translate" />
                                <img *ngIf="searchInputValue" (click)="searchInputValue = ''" loading="lazy"
                                    src="/media/icons/close.svg" alt="المستودع الرقمي" />
                            </div>
                            <button [disabled]="!searchInputValue" style="width: 62px; margin-inline: 16px;"
                                class="btn_secondary without-min" (click)="onSearchClick(searchInputValue)"
                                type="button" translate="hero.buttonsearch" tabIndex="0"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Ends :Hero section -->

    <!-- starts :libraries section -->
    <section class="featured-libraries-section">
        <div class="section-header pt-4">
            <h5 translate="home.topLibraries"></h5>
            <a routerLink="/libraries" translate="home.viewAll"></a>
        </div>
        <div *ngIf="topLibraries$ | async as libraries; else topLibrariesSkeleton" class="w-100">
            <swiper-container *ngIf="!topLibrariesError() && libraries.length > 0" class="w-100 py-3" pagination="true" pagination-clickable="true" space-between="24"
                breakpoints='{"0": {"slidesPerView": 1}, "768": {"slidesPerView": 2}, "992": {"slidesPerView": 3}}'>
                <swiper-slide *ngFor="let lib of libraries">
                    <!-- Library item -->
                    <app-libraries-card [library]="lib" />
                </swiper-slide>
            </swiper-container>
            
            <div class="col-12 mt-4" *ngIf="topLibrariesError()">
                <div class="alert alert-warning text-center mb-0">
                    {{ 'errors.dataUnavailable' | translate: { default: 'عذراً، البيانات غير متاحة حالياً بسبب عطل فني. يرجى المحاولة لاحقاً.' } }}
                </div>
            </div>
        </div>
        <ng-template #topLibrariesSkeleton>
            <app-skeleton-card [count]="3"></app-skeleton-card>
        </ng-template>
    </section>
    <!-- Ends :libraries section -->
</div>

<!-- <section class="media-section py-4">
  <div class="container section-header">
      <h5 translate="home.media"></h5>
      <a routerLink="/media" translate="home.viewAll"></a>
  </div>
  <div class="d-none d-lg-block">
      <swiper-container #swiperEl pagination="true" pagination-clickable="true" slides-per-view="5" space-between="16"
          free-mode="true" navigation="true">
          <swiper-slide *ngFor="let item of media">
              <app-libraries-card [library]="item" />
          </swiper-slide>
      </swiper-container>
  </div>

  <div class="d-block d-lg-none container">
      <div class="row">
          <div class="col-md-4" *ngFor="let item of media">
              <app-libraries-card [library]="item" />
          </div>
      </div>
  </div>
</section> -->





<!-- starts :libraries section -->
<section class="container latest-additions-section">
    <div class="section-header latest-additions-header">
        <h5 translate="home.latestAdditions"></h5>
        <a [class.disabled-link]="true" aria-disabled="true" tabindex="-1" translate="home.viewAll"></a>
    </div>
    <div *ngIf="latestBiblios$ | async as biblios; else latestBibliosSkeleton" class="w-100">
        <swiper-container *ngIf="!latestBibliosError() && biblios.length > 0" class="w-100 py-3" pagination="true" pagination-clickable="true" space-between="24"
            breakpoints='{"0": {"slidesPerView": 1}, "768": {"slidesPerView": 2}, "992": {"slidesPerView": 3}}'>
            <swiper-slide *ngFor="let bib of biblios">
                <!-- Library item -->
                <app-index-card [item]="bib" />
            </swiper-slide>
        </swiper-container>
        
        <div class="col-12 mt-4" *ngIf="latestBibliosError()">
            <div class="alert alert-warning text-center mb-0">
                {{ 'errors.dataUnavailable' | translate: { default: 'عذراً، البيانات غير متاحة حالياً بسبب عطل فني. يرجى المحاولة لاحقاً.' } }}
            </div>
        </div>
    </div>
    <ng-template #latestBibliosSkeleton>
        <app-skeleton-card [count]="3"></app-skeleton-card>
    </ng-template>
</section>
<!-- Ends : libraries section -->

<!-- Starts : visiting hours section -->
<section class="container visiting-hours-section my-5" *ngIf="kawLibrary$ | async as kaw">
    <div class="section-header">
        <h5>{{ 'home.visitingHours' | translate }}</h5>
    </div>
    
    <div class="row">
        <div class="col-md-6 col-lg-4">
            <div class="visiting-hours-card" *ngIf="kaw.library_hours && kaw.library_hours.length > 0">
                <div class="hours-content">
                    <ng-container *ngFor="let hour of kaw.library_hours">
                        <div class="hours-row" *ngIf="hour.open_time && hour.close_time">
                            <div class="line">
                                <span class="label" *ngIf="hour.start_day === hour.end_day">
                                    {{ 'days.single' | translate: { day: ('days.' + hour.start_day | translate) } }}
                                </span>
                                <span class="label" *ngIf="hour.start_day !== hour.end_day">
                                    {{ 'days.range' | translate: { start: ('days.' + hour.start_day | translate), end: ('days.' + hour.end_day | translate) } }}
                                </span>
                            </div>
                            <div class="line">
                                <span class="label">({{ formatTime(hour.open_time).h }}:{{ formatTime(hour.open_time).m }} {{ 'time.' + formatTime(hour.open_time).ampm | translate }} - {{ formatTime(hour.close_time).h }}:{{ formatTime(hour.close_time).m }} {{ 'time.' + formatTime(hour.close_time).ampm | translate }})</span>
                            </div>
                        </div>
                    </ng-container>
                </div>

            </div>
        </div>
    </div>
</section>
<!-- Ends : visiting hours section -->


<!-- Ends : Footer -->